import { ModuleValueUniversal, SchemaModuleUniversal } from './module-universal';
import { JSONSchema } from '../types/json-schema';
import { FormComponent } from '../form.component';
import { Validator, FormProperty, PropertyGroup } from '../angular2-schema-form-shim';

import * as rawJSONSchemaModuleHepatobiliarySurgery from '../../schemas/module-hepatobiliary-surgery.json';

export class SchemaModuleHepatobiliarySurgery extends SchemaModuleUniversal {
  schema: JSONSchema<ModuleValueUniversal>;

  constructor() {
    super();

    this.loadSchema( rawJSONSchemaModuleHepatobiliarySurgery );
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-hepatobiliary-surgery.ts